// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25MDQ","toggleWrap":"styles_toggleWrap__1qasq","content":"styles_content__3CwFP","selectAreaCode":"styles_selectAreaCode__30oh3"};